import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "../../../styles/website/Navbar.css";
import WhiteLogo from "../../../assets/website/white-logo-full.svg";
import { useAuth } from "../../../context/AuthContext";

/* =========================================================
   داده‌ها
   ========================================================= */

const NAV_LINKS = [
  { label: "صفحه نخست", href: "/" },
  { label: "درباره ما", href: "/about" },
  { label: "کسب درآمد", href: "/earn" },
  { label: "بانک فروشگاه‌ها", href: "/shops" },
  { label: "تعرفه", href: "/pricing" },
  { label: "تماس با ما", href: "/contact" },
];

/* =========================================================
   جستجوی محصولات (کنار دکمه ورود)
   ========================================================= */

const SEARCH_HREF = "/searchproduct";

const SearchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
    <path
      d="M20 20l-3.5-3.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

/* =========================================================
   کامپوننت
   ========================================================= */

export default function Navbar() {
  const { user, logout } = useAuth();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // جلوگیری از اسکرول پس‌زمینه (عمودی و افقی) وقتی سایدبار بازه
  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isSidebarOpen]);

  const dashboardLink =
    user?.is_superuser || user?.role === "admin"
      ? "/panel/admin"
      : user?.role === "support"
        ? "/panel/supporter"
        : user?.role === "user"
          ? "/panel/user/dashboard"
          : "/panel/login";

  // بستن سایدبار با کلید Esc
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setIsSidebarOpen(false);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <>
      <div className="nav-inner tile">
        <div className="logo">
          <span className="logo-mark">
            <img className="logo-dokana" src={WhiteLogo} alt="" />
          </span>
          <span className="logo-text">دُکانا</span>
        </div>

        {/* منوی دسکتاپ */}
        <nav className="nav-desktop">
          <ul>
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        {/* دکمه‌های دسکتاپ */}
        <div className="nav-cta">
          <a href={SEARCH_HREF} className="btn btn-ghost btn-sm nav-search-btn">
            <SearchIcon />
          </a>
          <a href={dashboardLink} className="btn btn-ghost btn-sm">
            ورود
          </a>
          <a href="/panel/login" className="btn btn-primary btn-sm">
            فروشگاه خودت رو بساز
          </a>
        </div>

        {/* آیکون‌های موبایل: لاگین + منو */}
        <div className="nav-mobile-actions">
          <a
            href={SEARCH_HREF}
            className="nav-login-btn"
            aria-label="جستجوی محصولات"
          >
            <SearchIcon />
          </a>

          <a
            href={dashboardLink}
            className="nav-login-btn"
            aria-label="ورود به حساب کاربری"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12Z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4 21.5c0-4.4 3.6-8 8-8s8 3.6 8 8"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>

          <button
            type="button"
            className="nav-menu-btn"
            onClick={() => setIsSidebarOpen(true)}
            aria-label="باز کردن منو"
            aria-expanded={isSidebarOpen}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 6h18M3 12h18M3 18h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* سایدبار و اورلی با Portal مستقیم به body تزریق می‌شن
         تا از stacking context هر والدی (مثل هدر) فرار کنن
         و همیشه روی محتوای صفحه بمونن */}
      {typeof document !== "undefined" &&
        createPortal(
          <div className="dokana">
            <div
              className={`nav-sidebar-overlay ${isSidebarOpen ? "open" : ""}`}
              onClick={() => setIsSidebarOpen(false)}
              aria-hidden="true"
            />

            <aside
              className={`nav-sidebar ${isSidebarOpen ? "open" : ""}`}
              role="dialog"
              aria-modal="true"
            >
              <div className="nav-sidebar-header">
                <div className="logo">
                  <span className="logo-mark">
                    <img className="logo-dokana" src={WhiteLogo} alt="" />
                  </span>
                  <span className="logo-text">دُکانا</span>
                </div>
                <button
                  type="button"
                  className="nav-sidebar-close"
                  onClick={() => setIsSidebarOpen(false)}
                  aria-label="بستن منو"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M6 6l12 12M18 6L6 18"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>

              <ul className="nav-sidebar-links">
                {NAV_LINKS.map((link) => (
                  <li key={link.label}>
                    <a href={link.href} onClick={() => setIsSidebarOpen(false)}>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </aside>
          </div>,
          document.body,
        )}
    </>
  );
}
